import {
	Button,
	Colors,
	DialogContainer,
	Modal,
	ModalFooter,
	ModalInputBox,
	ModalTitle,
	ModalTitleContainer,
	TextFieldWrapper,
} from "@factorearth/component-library";
import Svg from "components/Svg/Svg";
import React, { useRef, useState } from "react";
import { FiX } from "react-icons/fi";
import styles from "./UploadFileButton.module.scss";

interface UploadFileButtonProps {
	accept: string;
	color: Colors;
	title: string;
	onSubmit: (e: File | null) => Promise<void>;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	open: boolean;
}

function UploadFileButton(props: UploadFileButtonProps) {
	const { accept, setOpen, open, color, title, onSubmit } = props;

	const [selectedFile, setSelectedFile] = useState<File | null>(null);
	const [processing, setProcessing] = useState(false);

	const fileInputRef = useRef<HTMLInputElement>(null);

	async function submit() {
		setProcessing(true);
		await onSubmit(selectedFile);
		setProcessing(false);
		setOpen(!open);
	}

	return (
		<Modal colorPalette={color} open={open} setOpen={setOpen}>
			<DialogContainer>
				{processing ? (
					<Svg icon="SPINNER" />
				) : (
					<>
						<ModalTitleContainer>
							<ModalTitle>{title}</ModalTitle>
							<FiX onClick={() => setOpen(false)} size={24} />
						</ModalTitleContainer>
						<ModalInputBox>
							<div className={styles.inputContainer}>
								<label htmlFor="file-upload">
									<Button
										colorPalette={color}
										style={{ whiteSpace: "nowrap", height: "38px" }}
										variant="outlined"
										label="Choose File"
										onClick={() => fileInputRef.current?.click()}
									/>
								</label>
								<TextFieldWrapper colorPalette={color} value={selectedFile?.name || "No File Chosen"} disabled />
								<input
									id="file-upload"
									type="file"
									ref={fileInputRef}
									onChange={(e) => setSelectedFile(e.target.files?.[0] || null)}
									onClick={(e) => {
										// e.target.value = null;
										setSelectedFile(null);
									}}
									accept={accept}
									// value={selectedFile?.name || "No File Chosen"}
									name="upload-file-input"
									className={styles.uploadJson_input}
								/>
							</div>
						</ModalInputBox>
						<ModalFooter>
							<Button variant="filled" colorPalette={color} label="Submit" onClick={submit} />
						</ModalFooter>
					</>
				)}
			</DialogContainer>
		</Modal>
	);
}

export default UploadFileButton;
